import BaseCampaignOverviewSubjectsIndexController from 'cio/pods/base/overview/subjects/index/controller';
export default class CampaignOverviewSubjectsIndexController extends BaseCampaignOverviewSubjectsIndexController {}

declare module '@ember/controller' {
  interface Registry {
    'campaigns.campaign.overview.subjects.index': CampaignOverviewSubjectsIndexController;
  }
}
